import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/communications')({
  component: CommunicationsLayout,
})

function CommunicationsLayout() {
  return <Outlet />
}

